import { humanizeSnakeCase } from './humanize-snake-case';

export function formatSourceLabel({
  sourceType,
}: {
  sourceType?: string | null;
}): string | null {
  if (!sourceType) {
    return null;
  }

  if (sourceType === 'CONNECTOR_SUBNET') {
    return 'Subnet';
  }

  return humanizeSnakeCase(sourceType);
}
